import WorkItemPersist from '@/domain/work-item/work-item-persist.entity';

export default class WorkItemPostTask extends WorkItemPersist {
  assignedTo: string[];

  constructor(obj: any) {
    super(obj);
    this.assignedTo = obj.assignedTo || [];
  }

  public static of(value: any): WorkItemPostTask {
    return new WorkItemPostTask(value || {});
  }
}
